import { gql } from "apollo-boost"

export const UPDATE_ACTIVITY_SCHEDULE = gql`
  mutation updateSchedule($scheduleData: CreateActivitySchedule!) {
    UpdateActivityScheduleById(scheduleData: $scheduleData) {
      id
      createdAt
      place
      startTime
      endTime
      scheduledAt
    }
  }
`